/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_LaunchInputs */

const en_vc_onl_launch = /** @type {(inputs: Vc_Onl_LaunchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch VectorCraft`)
};

const zh_vc_onl_launch = /** @type {(inputs: Vc_Onl_LaunchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启动 VectorCraft`)
};

/**
* | output |
* | --- |
* | "Launch VectorCraft" |
*
* @param {Vc_Onl_LaunchInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_launch = /** @type {((inputs?: Vc_Onl_LaunchInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_LaunchInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_launch(inputs)
	return zh_vc_onl_launch(inputs)
});
export { vc_onl_launch as "vc.onl.launch" }